let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iTmpz")).then(() => parcelRequire('l5vdF'));